import React from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



// 프로그램 추가
export default function ProgramCreateDialog(param) {
    const [projectId, setProjectId] = React.useState('');

    const [name, setName] = React.useState(''); // 프로그램 명
    const [durationValue, setDurationValue] = React.useState('');     // 제공기간(db 변수)
    const [durationType, setDurationType] = React.useState('');       // 제공기간(db 변수)
    const [durationView, setDurationView] = React.useState('');       // 제공기간(화면 변수)
    const [startPoint, setStartPoint] = React.useState('');           // 가입기준(db 변수)
    const [startPointView, setStartPointView] = React.useState('');   // 가입기준(화면 변수)
    const [startDate, setStartDate] = React.useState('');             // 판매기간 시작
    const [endDate, setEndDate] = React.useState('');                 // 판매기간 종료


    // 프로그램 생성
    async function saveProgram(){
        if(name === ''){ alert('프로그램 명을 확인하세요.'); return;}
        else if(durationValue === ''){ alert('제공기간을 확인하세요.'); return;}
        else if(startPoint === ''){ alert('가입기준을 확인하세요.'); return;}
        else if(startDate === '' || endDate === ''){ alert('판매기간을 확인하세요.'); return;}

        const sDate = date_to_str(startDate);
        const eDate = date_to_str(endDate);

        var url = axiosUrl.project + '/' + projectId + '/programs' ;
        await axios.post(url,{
            name: name,
            durationValue: durationValue,
            durationType: durationType,
            startPoint: startPoint,
            startDate: sDate,
            endDate: eDate,
            priority: 1
        })
        .then(function (response){ 
            // 프로젝트 리스트 정보 전체를 새로 내려받아 화면 업데이트
            param.callbackUpdateList();
            document.getElementById('programCreateClose').click();
         })
        .catch(function (e) {
            alert('프로그램 추가에 실패하였습니다 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] ProgramCreateDialog.saveProgram - ' + e.response.data.error.messagee);
        });

    }

    // 날짜 포멧 변경
    function date_to_str(format){
        var year = format.getFullYear();
        var month = format.getMonth() + 1;
        if(month<10) month = '0' + month;
        var date = format.getDate();
        if(date<10) date = '0' + date;

        return year + "-" + month + "-" + date;
}

    // 프로그램 명 세팅
    function onChangeName(e){
        setName(e.target.value);
    }

    // 제공기간 세팅
    function onChangeDuration(e){
        var val = e.target.value;
        
        setDurationView(val);
        if(val === '1'){
            setDurationValue('1');
            setDurationType('YEAR');
        }else if(val === '2'){
            setDurationValue('6');
            setDurationType('MONTH');
        }
        else if(val === '3'){
            setDurationValue('3');
            setDurationType('MONTH');
        }else {

        }
    }

    // 가입기준 세팅
    function onChangeStartPoint(e){
        var val = e.target.value;
        setStartPointView(val);
        if(val === '1'){
            setStartPoint('TODAY');
        }else if(val === '2'){
            setStartPoint('TOMORROW');
        }else{

        }
    }


    function reset(){
        setName('');
        setDurationView(0);
        setDurationType('');
        setDurationValue('');
        setStartPointView(0);
        setStartPoint('');
        setStartDate('');
        setEndDate('');
    }


    React.useEffect(() => {
        setProjectId(param.projectId);
    });


    return(
        <div className="modal fade" id="ProgramCreateDialog" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            
            <div className="modal-dialog  modal-dialog-centered" role="document">
                <div className="modal-content">
                <div className="modal-header contentColor">
                    <h5 className="modal-title" id="exampleModalLabel">프로그램 추가하기</h5>
                    <button type="button" id='programCreateClose' className="close" data-dismiss="modal" onClick={reset} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="input-group mb-3">
                        프로그램  <input type="text" className="form-control ml-4" aria-label="Amount (to the nearest dollar)" value={name} onChange={onChangeName} />
                    </div>

                    <div className="input-group mb-3">
                        제공기간  
                            <select value={durationView} id="duration" name="duration" className="custom-select ml-4" onChange={onChangeDuration}>
                                <option value="0">선택하세요</option>
                                <option value="1">1년</option>
                                <option value="2">6개월</option>
                                <option value="3">3개월</option>
                            </select>
                    </div>

                    <div className="input-group mb-3">
                        가입기준  
                            <select value={startPointView} id="startPoint" name="startPoint"  className="custom-select ml-4" onChange={onChangeStartPoint} >
                                <option value="0">선택하세요</option>
                                <option value="1" >오늘</option>
                                <option value="2">내일</option>
                            </select>
                    </div>

                    <div className="input-group mb-3">
                        판매기간
                      
                            <DatePicker
                                type='text'
                                className="dateRangePicker form-control ml-4"
                                id='startDate'
                                selected={startDate}
                                onChange={date => setStartDate(date)}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                dateFormat="yyyy-MM-dd"
                                placeholderText='시작일을 지정하세요'
                            />
                            <DatePicker
                                className="dateRangePicker form-control ml-2"
                                id='endDate'
                                selected={endDate}
                                onChange={date => setEndDate(date)}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                dateFormat="yyyy-MM-dd"
                                placeholderText='종료일을 지정하세요'
                        />
                        
                    </div>


                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={reset}  >닫기</button>
                    <button type="button" className="btn btn-primary" onClick={saveProgram}>저장</button>
                </div>
                </div>
            </div>
            </div>

    );
}